import { FuelInteractiveIcon, FuelTypography } from '@frete.com/fuel-react';
import AppContext from 'context';
import { useAppContext } from 'hooks/useAppContext';
import React, { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { ContentHeaderInformation } from './styled';

const Header: FC = () => {
  const {
    state: {
      deviceSize: { isDesktop },
    },
  } = useAppContext();

  const navigate = useNavigate();

  const {
    state: {
      truckers: { meta },
      suggestedTruckers: { errorSuggested },
      searchTruckers: { errorSearch },
    },
  } = useContext(AppContext);

  const titleSize = isDesktop ? 'heading-md' : 'heading-sm';
  const descriptionSize = isDesktop ? 'body-md' : 'body-sm';
  const descriptionFreightDestination = `Frete para ${meta?.freight.destination.city}, ${meta?.freight.destination.federativeUnit} | 
  ${meta?.freight.code}`;

  return (
    <>
      {errorSuggested && !errorSearch && <>Não foi possível carregar informações do frete</>}

      {(meta !== null || errorSearch) && !errorSuggested && (
        <FuelFlex defaultProps={{ gap: 'km5' }} mdProps={{ gap: 'km3' }}>
          <FuelInteractiveIcon
            data-testid="go-back-button"
            icon="close"
            size="large"
            onClick={() => navigate('/meus-fretes')}
          />

          <ContentHeaderInformation>
            <FuelTypography weight="bold" size={titleSize}>
              Lista de Motoristas
            </FuelTypography>

            <FuelTypography weight="regular" size={descriptionSize} color="neutral-default">
              {descriptionFreightDestination}
            </FuelTypography>
          </ContentHeaderInformation>
        </FuelFlex>
      )}
    </>
  );
};

export default Header;
